export function getElRect(element: HTMLDivElement): DOMRect {
  return element.getBoundingClientRect();
}
